import AdSlot from "@pageContent/AdSlot";
import { AD_IDS } from "@constants/consts";
import { useHostConfig } from "@utils/common/getHostConfig";
import * as Styled from "./ArticleCollectionPanels.styled";
import ArticlePanel from "./ArticlePanel";

const ArticleCollectionPanels: React.FC<{ shouldRenderAdSlot?: boolean }> = ({ shouldRenderAdSlot }) => {
  const {
    articleCollectionPanels: { topCollectionUrl, bottomCollectionUrl },
  } = useHostConfig();

  return (
    <Styled.ArticleCollectionPanelsContainer>
      <ArticlePanel url={topCollectionUrl} isNumeric />
      {shouldRenderAdSlot && <AdSlot id={AD_IDS.articlePanelBanner} />}
      {bottomCollectionUrl && <ArticlePanel url={bottomCollectionUrl} />}
    </Styled.ArticleCollectionPanelsContainer>
  );
};

export default ArticleCollectionPanels;
